// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"F1-z","refreshPageWarning":"G1-z","redirectMessageText":"H1-z"};